module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/stepper_up_purple@1x.png?0.0.53";